import type { IconSvgObject } from './types';

const Audit02Icon: IconSvgObject = [
  ["path", { d: "M10 11.5L2.90616 17.547C1.76853 18.495 1.69049 20.2152 2.73763 21.2624C3.78476 22.3095 5.50499 22.2315 6.45302 21.0938L12.5 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 12L16 18M12 2L6 7.5M11.3346 2.76186C11.3346 2.76186 14.3822 5.04758 16.6679 7.33329C18.9537 9.61901 21.2394 12.6666 21.2394 12.6666M16.6679 17.2381C16.6679 17.2381 13.6203 14.9523 11.3346 12.6666C9.0489 10.3809 6.76318 7.33329 6.76318 7.33329", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Audit02Icon;
